import { Loader } from '@comall-backend-builder/core/lib/loaders';
import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
import { localStorage } from '@comall-backend-builder/core/lib/services';
import { converSecondsToDate } from '../services';

// 直播间列表
export const LiveRoomListLoader: Loader = {
    // 直播列表
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/room';
        params = {
            ...params,
            page: params.page || 1,
            per_page: 20,
        };
        const response: any = await api.get(params, config);
        response.result.map((item: any) => {
            item.id = item.roomid;
            item.dateTimeRange = {
                start: converSecondsToDate(item.startTime),
                end: converSecondsToDate(item.endTime),
            };
        });
        return response;
    },
    // 修改列表
    put: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/live/room/set';
        params.roomId = params.id;
        delete params.id;
        const response: any = await api.post(params, config);
        return response;
    },

    // 新增直播
    post: async function(params: any, config: ApiRequestConfig) {
        // 直播日期格式修改
        if (params && params.dateTimeRange) {
            params.startTime = new Date(params.dateTimeRange.start).getTime() / 1000;
            params.endTime = new Date(params.dateTimeRange.end).getTime() / 1000;
            delete params.dateTimeRange;
        }

        // 直播背景图
        if (params && params.coverImg) {
            params.coverImgPath = params.coverImg;
            delete params.coverImg;
        }

        // 直播分享图
        if (params && params.shareImg) {
            params.shareImgPath = params.shareImg;
            delete params.shareImg;
        }

        params.type = parseInt(params.type);
        params.screenType = parseInt(params.screenType);
        params.closeLike = parseInt(params.closeLike);
        params.closeGoods = parseInt(params.closeGoods);
        params.closeComment = parseInt(params.closeComment);

        config.apiPath = '/live/room';
        const response: any = await api.post(params, config);
        return response;
    },
};

// 直播间详情
export const LiveRoomDetailLoader: Loader = {
    get: async function(_params: any, _config: ApiRequestConfig) {
        return await new Promise((resolve, _reject) => {
            const liveRoomInfo: any = localStorage.get('LIVE_ROOM_INFO');
            liveRoomInfo.dateTimeRange = {
                start: converSecondsToDate(liveRoomInfo.startTime),
                end: converSecondsToDate(liveRoomInfo.endTime),
            };
            resolve(liveRoomInfo);
        });
    },
};

// 直播间商品
export const LiveRoomProductsLoader: Loader = {
    get: async function(_params: any, _config: ApiRequestConfig) {
        return await new Promise((resolve, _reject) => {
            const liveRoomInfo: any = localStorage.get('LIVE_ROOM_INFO');
            const result = liveRoomInfo.goods;
            result.map((item: any, key: number) => {
                item.id = key + 1;
                item.price = item.price / 100 + '元';
            });
            resolve({
                page: 1,
                perPage: 200,
                result,
                totalNum: 200,
                totalPage: 1,
            });
        });
    },
};
